module.exports = __webpack_public_path__ + "img/keyboard.884f87e2.svg";